module.exports = __webpack_public_path__ + "media/video.73020a8e.mp4";